export class LatLongItem {
  public static parse(proto: { lat: number; lon: number }) {
    return new LatLongItem(proto.lat, proto.lon);
  }

  public get lat() {
    return this._lat;
  }

  public get lon() {
    return this._lon;
  }

  constructor(
    private _lat: number,
    private _lon: number,
  ) {}
}
